import { useRef, useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import axios from "axios";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { API, MSG } from "./constantsFront";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import crypto from "crypto-js"
import { MsgContext } from "../../App";

/**
 * 職員登録・変更
 * @returns 
 */
function G0182StaffEdit() {
  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  const location = useLocation();
  let selectStaffId = "";

  if (location.state != null) {
    selectStaffId = location.state.ID;
    window.localStorage.setItem("selectStaffId", selectStaffId); // ローカルストレージに保存する
  } else {
    selectStaffId = window.localStorage.getItem("selectStaffId"); // ローカルストレージから取り出す
  }

  const [maxid, setMaxId] = useState(0);
  const [staffId, setStaffId] = useState(""); // 職員ID
  const [staffName, setStaffName] = useState(""); // 職員名
  const [affiliation, setAffiliation] = useState(""); // 所属課
  const [position, setPosition] = useState(""); // 役職
  const [password, setPassword] = useState({ value: "", showPassword: false }); // パスワード
  const [failCount, setFailCount] = useState("0"); // 失敗回数


  // 必須チェック用メッセージ
  const [staffIdMsg, setStaffIdMsg] = useState("");
  const [staffNameMsg, setStaffNameMsg] = useState(""); // 必須チェック用メッセージ(職員名)
  const [passwordMsg, setPasswordMsg] = useState(""); // 必須チェック用メッセージ(パスワード)
  const [failCountMsg, setFailCountMsg] = useState(""); // 失敗回数
  const [staffMain, setStaffMain] = useState(""); // Edit画面表題

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  const navigate = useNavigate();

  // let maxstaffid = "";
  let body = { authKey: API.API_KEY };

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (selectStaffId == -1) {
      // getMaxStaffId();
      setStaffMain("職員新規登録");
    } else {
      getStaff();
      setStaffMain("職員編集");
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, [])

  // 更新履歴取得
  async function getStaff() {
    body.staffId = selectStaffId;
    await axios.post("/m_staff/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let staffList = res.data.dataList;
      // 復号化
      const decrypted = crypto.AES.decrypt(staffList[0].password, 'key').toString(crypto.enc.Utf8);
      setStaffId(staffList[0].staff_id);
      setStaffName(staffList[0].staff_name);
      setAffiliation(staffList[0].affiliation);
      setPosition(staffList[0].position);
      setPassword({ value: decrypted, showPassword: false });
      setFailCount(staffList[0].fail_count);
    }).catch(error => {
      console.log('error:', error);
      setMsg(MSG.EXCEPTION);
    });
  }

  // staff_idの最大値取得
  // async function getMaxStaffId() {
  //   await axios.post("/m_staff/select/maxstaffid", body).then(res => {
  //     // データが取得できた時の処理
  //     maxstaffid = res.data.dataList;

  //     // staffidの最大値が0以上の場合は+1する
  //     if (maxstaffid[0].id != null && maxstaffid[0].id >= 0) {
  //       setMaxId(Number(maxstaffid[0].id) + 1);
  //     } else {
  //       setMaxId(0);
  //     }
  //   }).catch((err) => {
  //     console.log(err.request);
  //     if (err.request.status == 500) {
  //       return setMsg("例外が発生しました。管理者にお問い合わせください。");
  //     }
  //   });
  // }

  // 保存処理
  async function register() {
    try {
      console.log("保存処理開始");

      if (!staffId) {
        setStaffIdMsg("職員IDは必須です");
      } else {
        setStaffIdMsg("");
      }
      if (!staffName) {
        setStaffNameMsg("職員名は必須です");
      } else {
        setStaffNameMsg("");
      }

      if (!password.value) {
        setPasswordMsg("パスワードは必須です");
      } else {
        setPasswordMsg("");
      }
      if (!staffName || !password.value) {
        return;
      }

      // staff_idの振り分け
      // let staffId;
      // if (selectStaffId == -1) {
      //   // staffId = maxid;
      // } else {
      //   // staffId = selectStaffId;
      // }
      // 暗号化
      const encrypted = crypto.AES.encrypt(password.value, 'key').toString();

      // POST用データ作成
      body.staffId = staffId;
      body.staffName = staffName;
      body.affiliation = affiliation;
      body.position = position;
      body.password = encrypted;
      body.failCount = failCount;


      // insertとupdateを分岐させる
      if (selectStaffId == -1) {

        //職員ID　重複チェック
        body.staffId = staffId;
        let list = [];
        const res = await axios.post("/m_staff/select/auth", body).then(res => {
          // 取得チェック
          if (res.status != 200) {
            return;
          }
          list = res.data.dataList;
          // return;
        });

        if (list.length > 0) {
          setMsg("入力した職員IDは既に登録済みです。");
          return;
        }

        // insert
        const res2 = await axios.post("/m_staff/insert/auth", body);
        if (res2.status === 200) {
          console.log("insert成功");
        } else {
          console.log("insert失敗");
        }
      } else {
        // update
        const res3 = await axios.post("/m_staff/update/auth", body);
        if (res3.status === 200) {
          console.log("update成功");
        } else {
          console.log("update失敗");
        }
      }
      console.log("保存処理終了");
      return window.location.href = "./G0181StaffList";
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  const handleClickShowPassword = () => {
    setPassword({
      ...password,
      showPassword: !password.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg">
                <Stack spacing={2}>

                  <h1>{staffMain}</h1>
                  <TextField id="staffId" variant="outlined" value={staffId}
                    label="職員ID"
                    required
                    disabled={(selectStaffId != -1) ? true : false}
                    error={Boolean(staffIdMsg == "" ? false : true)}
                    helperText={staffIdMsg}
                    onChange={e => { setStaffId(e.target.value) }} />

                  <TextField id="staffName" variant="outlined" value={staffName}
                    label="職員名"
                    required
                    error={Boolean(staffNameMsg == "" ? false : true)}
                    helperText={staffNameMsg}
                    onChange={e => { setStaffName(e.target.value) }} />

                  <TextField id="password" variant="outlined" value={password.value}
                    label="パスワード"
                    required
                    type={password.showPassword ? 'text' : 'password'}
                    error={Boolean(passwordMsg == "" ? false : true)}
                    helperText={passwordMsg}
                    onChange={e => { setPassword({ value: e.target.value, showPassword: true }) }}
                    InputProps={{
                      endAdornment:
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {password.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                    }}
                  />

                  <TextField id="affiliation" variant="outlined" value={affiliation}
                    label="所属課"
                    onChange={e => { setAffiliation(e.target.value) }} />

                  <TextField id="position" variant="outlined" value={position}
                    label="役職"
                    onChange={e => { setPosition(e.target.value) }} />

                  <TextField id="failCount" variant="outlined" value={failCount}
                    label="失敗回数"
                    required
                    error={Boolean(failCountMsg == "" ? false : true)}
                    helperText={failCountMsg}
                    onChange={e => { setFailCount(e.target.value) }} />

                  <Stack spacing={2} direction="row">
                    <Button href="./G0181StaffList"
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>
                    <Button onClick={register} style={{ width: "200px" }}>登録</Button>
                  </Stack>

                  {/* </Box> */}
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default G0182StaffEdit;